var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "li",
    {
      staticClass: "cw-activity-item",
    },
    [
      _vm.item.username
        ? _c(
            "p",
            {
              staticClass: "cw-activity-item-user",
            },
            [
              _c(
                "a",
                {
                  attrs: {
                    href: _vm.userUrl,
                  },
                },
                [
                  _c("studip-icon", {
                    attrs: {
                      role: "inactive",
                      shape: "headache",
                    },
                  }),
                  _vm._v(_vm._s(_vm.item.username)),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.item.readableDate
        ? _c(
            "p",
            {
              staticClass: "cw-activity-item-date",
            },
            [
              _c("studip-icon", {
                attrs: {
                  role: "inactive",
                  shape: "timetable",
                },
              }),
              _vm._v(_vm._s(_vm.item.readableDate) + "\n    "),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "cw-activity-item-element",
        },
        [
          _c(
            "a",
            {
              attrs: {
                href: _vm.linkUrl,
                title: _vm.elementTitle,
              },
            },
            [
              _c("studip-icon", {
                attrs: {
                  role: "inactive",
                  shape: "content2",
                },
              }),
              _vm._v(_vm._s(_vm.unitTitle) + " | " + _vm._s(_vm.breadcrumb)),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _vm.content
        ? _c(
            "p",
            {
              staticClass: "cw-activity-item-content",
            },
            [
              _c("studip-icon", {
                attrs: {
                  role: "inactive",
                  shape: _vm.shape,
                },
              }),
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(_vm.content),
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }